import React from 'react';

const SectionTitle = ({ children, className = '' }) => {
  return (
    <h2 className={`text-4xl font-bold text-center mb-12 bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-transparent ${className}`}>
      {children}
    </h2>
  );
};

export default SectionTitle;